import request from '@/utils/request'

// 获取设备型号列表
export const getEquipModelLists = (data) => {
    return request({
        url: '/equipModel/lists',
        params: data
    })
}

// 设备型号-详情
export const getEquipModelDetail = (id) => {
    return request({
        url: `/equipModel/${id}`
    })
}

// 设备品牌型号-tree
export const getEquipModelBrandTree = () => {
    return request({
        url: '/equipModel/brand/tree'
    })
}

// 设备型号-修改
export const putEquipModel = (data) => {
    return request({
        url: '/equipModel/manage',
        method: 'PUT',
        data
    })
}

// 设备型号-添加
export const addEquipModel = (data) => {
    return request({
        url: '/equipModel/manage',
        method: 'POST',
        data
    })
}

// 设备型号-删除
export const delEquipModel = (id) => {
    return request({
        url: `/equipModel/${id}`,
        method: 'DELETE'
    })
}

// 批量处理设备型号
export const batchEquipModel = (method, data) => {
    return request({
        url: '/equipModel/manage',
        method: 'PATCH',
        data: {
            method,
            data
        }
    })
}
// 设备型号-设置详情
export const getSettingDetail = (id) => {
    return request({
        url: `/equip/setting/${id}`
    })
}

// 设备型号-设置参数
export const postSetting = (id, data) => {
    return request({
        url: `/equip/setting/${id}`,
        method: 'POST',
        data
    })
}

// 设备型号-清除参数设置
export const removeSetting = (id) => {
    return request({
        url: `/equip/setting/${id}`,
        method: 'DELETE'
    })
}
/**
 * 设备型号--获取设备类型 */
export const getEquipModelOptionLists = (params) => {
    return request({
        url: '/equipModel/option/lists',
        params: params
    })
}

/**
 * 设备型号--通信类型
 */
export const getCommunicationType = () => {
    return request({
        url: '/equipModel/options'
    })
}

// 根据型号获取字段信息
export const getEquipModelFieldLists = (data) => {
    return request({
        url: '/equipModel/field/lists',
        params: data
    })
}

/**
 * 下载导入模板
 */
export const getEquipModelTemplateUrl = () => {
    return request({
        url: '/equipModel/excel/imports'
    })
}

// 设备型号-导出
export const importsEquipModel = (data) => {
    return request({
        url: '/equipModel/excel/imports',
        method: 'POST',
        data
    })
}

/**
 * 下载类型导入模板
 */
export const getEquipTypeTemplateUrl = () => {
    return request({
        url: '/equipType/excel/imports'
    })
}
// 设备类型-导出
export const importsEquipType = (data) => {
    return request({
        url: '/equipType/excel/imports',
        method: 'POST',
        data
    })
}
